module.exports = __webpack_public_path__ + "img/testimonial_0.2d76307d.png";